import PriceInput from './PriceInput';

/**
 * Shared "Price (USD)" form field used by every editor (Course, Practice,
 * Event, Group) so they all look the same: label, "$" prefix, input, and a
 * hint to the right that explains free vs paid. USD only.
 */
export default function PriceField({
  cents,
  onChangeCents,
  paidHint = 'Paid — bought via Stripe on the web.',
  freeHint = '$0 = free.',
}) {
  return (
    <div style={{ display: 'flex', gap: 12, alignItems: 'flex-end', flexWrap: 'wrap' }}>
      <div className="form-field" style={{ maxWidth: 180 }}>
        <label>Price (USD)</label>
        <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
          <span style={{ color: 'var(--muted)' }}>$</span>
          <PriceInput cents={cents} onChangeCents={onChangeCents} style={{ maxWidth: 120 }} />
        </div>
      </div>
      <div style={{ color: 'var(--muted)', fontSize: '0.8125rem', paddingBottom: 12 }}>
        {cents > 0 ? paidHint : freeHint}
      </div>
    </div>
  );
}
